export const Post19802 = () => {
    return(
        <div class="w-full text-left">
            <h4 className="text-[22px] font-semibold py-2">
                Operational Efficiencies, Litigation Prediction and avoidance, Fraud detection with Charlee™
            </h4>
            <h4 className="text-[22px] text-[#22c0b1] font-semibold py-2">
                Five Minutes with the Infinilytics’ Innovation Team
            </h4>
            <p className="mt-4">
                The last several months have caused the insurance industry to change in so many ways. Some insurance companies are reporting a decline in revenue while others are maintaining or have increased. The pandemic, hurricanes, and wildfires cause turmoil in the claims systems with backlogs, delayed payment processing, lack of claims resources, and perennial charlatans and fraudsters. They always emerge in these catastrophes preying on victims and insurance carriers.
            </p>
            <div className="text-center">
                <a className="mt-4 mx-auto bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" href="/blog-photos/Automating-Claims-Decisions-With-A.I.-Based-Insights.pdf" target="_blank">
                    Download PDF
                </a>
            </div>
            
        </div>
    )
}